import React from 'react';

import classnames from 'classnames';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalRequireEmail = ({
  handleChange,
  requireEmail,
}) => {
  const intl = useIntl();

  return (
    <div className="share-select-require-email share-setting">
      <Label for="inpSelectRequireEmail" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Require email' })}
          <HelpIcon id="share-require-email">
            {intl.formatMessage({ defaultMessage: 'Require recipients to enter an email address before accessing this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-require-email" simple={true} />
          {userHasFeature('share-require-email') && (
          <div className="switch-control input-inner">
            <Input
              type="checkbox"
              name="select-require-email"
              id="inpSelectRequireEmail"
              value={true}
              checked={requireEmail}
              onChange={handleChange}
              disabled={!canUserManageShare()}
            />
            <i />
          </div>
          )}
        </div>
      </Label>
    </div>
  );
};

ShareModalRequireEmail.propTypes = {
  requireEmail: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalRequireEmail;
